










































import { Component, Vue, Prop, Provide, Mixins, Watch } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import { PicturePaperItem } from '@/components'
import { getPictureBookInfo } from './model/api'

@Component({
  components: {
    MainTemplate,
    PicturePaperItem
  }
})
export default class PaperDetail extends Mixins() {
  public loading = false
  public isBand = true
  // 详情
  public detailInfo: any = {}
  // docId
  public docId = ''

  // computed
  public get userName() {
    return this.$store.state.user_info ? this.$store.state.user_info.nickname : undefined
  }
  public get id() {
    return this.$route.query.id
  }
  public mounted() {
    if (this.userName) {
      this.courseWareDetail(this.id)
    } else {
      window.location.href = '/index'
    }
    document.oncontextmenu = () => false
  }
  @Watch('id')
  onIdChange(val) {
    this.courseWareDetail(val)
  }
  // changeFavoriteList
  changeFavoriteList() {
    this.courseWareDetail(this.id)
  }
  // 获取详情
  public async courseWareDetail(id) {
    try {
      const res: any = await getPictureBookInfo({
      doc_id: id
      })
      if (res.success) {
        this.detailInfo = res.data
        this.docId = this.detailInfo.doc_id
      } else {
        window.location.href = '/courseware'
      }
    } catch (err) {
      if (err.status === 429) {
        this.detailInfo = null
        return
      }
      window.location.href = '/courseware'
    }
  }
}
